import { createGlobalStyle } from "styled-components";
import styled from "styled-components";

export const ModalGlobalStyles = createGlobalStyle`
	.benefit-update-modal {
		width: min(600px, calc(100vw - 32px));
		max-width: 600px;
		margin: 24px auto;
	}

	.benefit-update-modal .modal-content {
		display: flex;
		max-height: calc(100vh - 48px);
		border: 0;
		border-radius: 14px;
		box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
		overflow: hidden;
	}

	.benefit-update-modal .modal-header {
		flex: 0 0 auto;
		align-items: flex-start;
		padding: 24px 32px;
		border-bottom: 1px solid #e3e6eb;
	}

	.benefit-update-modal .modal-header .close {
		margin: -4px -4px 0 16px;
		padding: 8px;
		color: #65707d;
		font-size: 32px;
		opacity: 1;
	}

	.benefit-update-modal .modal-body {
		flex: 1 1 auto;
		overflow-y: auto;
		padding: 28px 32px 32px;
		background: #fff;
	}

	@media (max-width: 620px) {
		.benefit-update-modal {
			width: calc(100vw - 16px);
			margin: 8px auto;
		}

		.benefit-update-modal .modal-content {
			max-height: calc(100vh - 16px);
		}

		.benefit-update-modal .modal-header,
		.benefit-update-modal .modal-body {
			padding: 20px;
		}
	}
`;

export const HeaderContent = styled.div`
	min-width: 0;

	h2 {
		margin: 0 0 4px;
		color: #252b31 !important;
		font-size: 26px;
		font-weight: 700;
	}

	p {
		margin: 0;
		color: #737c89;
		font-size: 16px;
		overflow-wrap: anywhere;
	}
`;

export const ModalContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 22px;
`;

export const Section = styled.div`
	flex: 0 0 auto;
	border: 1px solid #dfe3e8;
	border-radius: 10px;
	overflow: hidden;
	background: #fff;
`;

export const SectionHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 18px 30px;
	border-bottom: 1px solid #dfe3e8;

	h3 {
		margin: 0;
		color: #2c3238 !important;
		font-size: 20px;
		font-weight: 700;
	}

	p {
		margin: 2px 0 0;
		color: #818996;
		font-size: 14px;
	}
`;

export const ProviderHeader = styled.div`
	padding: 15px 20px;
	border-bottom: 1px solid #dfe3e8;
	background: #f5f6f8;
	color: #596371;
	font-size: 14px;
	font-weight: 700;
`;

export const ProviderGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr;

	@media (max-width: 620px) {
		grid-template-columns: 1fr;
	}
`;

export const ProviderField = styled.div`
	min-height: 86px;
	padding: 16px 20px;
	border-bottom: 1px solid #e2e5e9;
	overflow-wrap: anywhere;

	&:nth-child(odd) {
		border-right: 1px solid #e2e5e9;
	}

	span {
		display: block;
		margin-bottom: 4px;
		color: #8a9098;
		font-size: 14px;
	}

	strong {
		color: #20252a;
		font-size: 17px;
	}

	@media (max-width: 620px) {
		border-right: 0 !important;
	}

	&:last-child {
		border-bottom: 0;
	}
`;

export const FormBody = styled.div`
	padding: 24px 30px;
`;

export const FieldsRow = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 16px;

	@media (max-width: 620px) {
		grid-template-columns: 1fr;
	}
`;

export const Field = styled.label`
	display: flex;
	flex-direction: column;
	gap: 6px;
	margin: 0;
	color: #343a40;
	font-size: 14px;
	font-weight: 600;

	select,
	input,
	textarea {
		width: 100%;
		border: 1px solid #dfe3e8;
		border-radius: 8px;
		padding: 11px 14px;
		background: #fff;
		color: #343a40;
		font-size: 15px;
		font-weight: 400;
	}

	textarea {
		min-height: 96px;
		resize: vertical;
	}
`;

export const FullField = styled(Field)`
	margin-top: 16px;
`;

export const SectionActions = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-top: 18px;
`;

export const PrimaryButton = styled.button`
	border: 0;
	border-radius: 8px;
	padding: 11px 22px;
	background: #584c9c;
	color: #fff;
	font-size: 15px;
	font-weight: 700;
	cursor: pointer;

	&:disabled {
		cursor: not-allowed;
		opacity: 0.6;
	}
`;

export const StatusBadge = styled.span`
	border-radius: 4px;
	padding: 4px 12px;
	background: ${props => props.color};
	color: #fff;
	font-size: 11px;
	font-weight: 700;
	text-transform: uppercase;
`;

export const ObservationsBody = styled.div`
	display: flex;
	flex-direction: column;
	gap: 14px;
	padding: 24px 30px;
`;

export const Observation = styled.article`
	padding: 14px 16px;
	border-radius: 8px;
	background: #f2f3f5;

	header {
		margin-bottom: 4px;
		color: #747d88;
		font-size: 13px;
	}

	strong {
		color: #343a40;
	}

	p {
		margin: 0;
		color: #252b31;
		font-size: 15px;
		white-space: pre-wrap;
	}
`;

export const Divider = styled.hr`
	width: 100%;
	margin: 4px 0;
	border: 0;
	border-top: 1px solid #e1e4e8;
`;

export const EmptyState = styled.div`
	padding: 24px;
	color: #7a838e;
	text-align: center;
`;
